import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { SvgMatType } from "src/app/constants/icons";
import { EnrollmentBenefitCategoryItem } from "src/app/models/enrollment-category";
import { EnrollmentCategoryOptions } from "src/app/models/enrollment-option";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";
import { SessionService } from "src/app/services/storage/session.service";

@Component({
    selector: 'mwp-benefit-enrollment-faux-category',
    templateUrl: './faux-category.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BenefitEnrollmentFauxCategoryComponent implements OnInit {
    @Input() public enrollmentCategoryOptions: EnrollmentCategoryOptions;
    @Output() public gotoNextCategroy: EventEmitter<any> = new EventEmitter();
    
    public displayDefaultCard: boolean;
    public displayNextRequiredCategoryButton: boolean;
    public isAgent: boolean;
    public svgType: SvgMatType;

    constructor(
        private enrollmentManagerService: EnrollmentManagerService,
        private sessionService: SessionService,
    ){
    }

    ngOnInit(): void {
        if (this.enrollmentCategoryOptions.displayDefaultFauxHTML) {
            this.displayDefaultCard = true;
            this.isAgent = this.sessionService.session.isAgent;
        }

        if (!this.enrollmentManagerService.manager.isCheckoutEnabled) {
            let l_CurrentIndex: number;
            let l_UncompletedRequiredCategories: boolean;
            this.enrollmentManagerService.manager.benefitCategories.forEach((bc: EnrollmentBenefitCategoryItem, index) => {
                if (!l_CurrentIndex && bc.id == this.enrollmentManagerService.manager.selectedCategoryId)
                    l_CurrentIndex = index;

                if (!l_UncompletedRequiredCategories && bc.isRequired == true && bc.isCompleted == false)
                    l_UncompletedRequiredCategories = true;
            });
            
            this.displayNextRequiredCategoryButton = (l_CurrentIndex == this.enrollmentManagerService.manager.benefitCategories.length - 1) && l_UncompletedRequiredCategories;
        }
    }

    gotoNextCategory(): void {
        this.gotoNextCategroy.emit();
    }
}